<div
  class="modal fade"
  [id]="'deleteModal-' + deleteModalId"
  tabindex="-1"
  role="dialog"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  aria-labelledby="deleteModalLabel"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-2" id="deleteModalLabel">
          {{ getModalTitle() }}
        </h1>
        <button
          type="button"
          class="btn-close cursor-pointer"
          data-bs-dismiss="modal"
          [attr.aria-label]="'close' | translate"
        ></button>
      </div>
      <div class="modal-body fs-4">
        {{ getModalMessage() }}
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary cursor-pointer"
          data-bs-dismiss="modal"
        >
          {{ "no" | translate }}
        </button>
        <button
          (click)="deleteItem(deleteModalId)"
          type="button"
          class="btn btn-danger cursor-pointer"
          data-bs-dismiss="modal"
        >
          {{ "yes" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
